import type { DocNode } from '@atlaskit/adf-schema/doc';
import { reduce } from '@atlaskit/adf-utils/reduce';

import { getOrParseContentBodyAdf } from '@confluence/adf-analysis-core/entry-points/getOrParseContentBodyAdf.ts';
import { expValEquals } from '@confluence/feature-experiments';

const extensionNodeSet = new Set(['extension', 'inlineExtension', 'bodiedExtension']);

export const getContentStats = (draftBody: string | null | undefined, contentId?: string): {} => {
	if (!draftBody) {
		return {};
	}

	try {
		let doc: DocNode;
		if (contentId && expValEquals('cc-proj-xl-use-shared-adf-parsing', 'isEnabled', true)) {
			const result = getOrParseContentBodyAdf(contentId, draftBody);
			if (!result.ok) return {};
			doc = result.doc;
		} else {
			doc = JSON.parse(draftBody);
		}
		return reduce(
			doc,
			(acc, node) => {
				const key = extensionNodeSet.has(node.type)
					? `${node.type}:${node.attrs?.extensionKey}`
					: node.type;

				acc[key] = (acc[key] || 0) + 1;
				return acc;
			},
			{},
		);
	} catch (e) {
		return {};
	}
};
